import * as yup from 'yup';
import { Row, RenderConfig, TextInput, AsyncSelect } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	PERMISSION_SET_NAME: 'name',
	PERMISSION_SET_DESCRIPTION: 'description',
	SELECT_PERMISSIONS: 'permissionIds'
};
export const validationSchema = yup.object().shape({
	name: yup.string().required('Permission Set Name is required'),
	description: yup.string().required('description is required')
});

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.PERMISSION_SET_NAME),
	new Row(FORM_FIELD_KEYS.PERMISSION_SET_DESCRIPTION),
	new Row(FORM_FIELD_KEYS.SELECT_PERMISSIONS)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.PERMISSION_SET_NAME]: new RenderConfig()
		.setName('name')
		.setLabel('Permission Set Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.PERMISSION_SET_DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Permission Set Description')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.SELECT_PERMISSIONS]: new RenderConfig()
		.setName('permissionIds')
		.setLabel('Select Permissions')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			multi: true
		})
};
